import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import ModalAlterarData from './ModalAlterarData';
import { InventarioType } from '../../../../data/sngpc';

interface BotaoAlterarDataProps {
    inventario: InventarioType | null;
    disabled?: boolean;
}

const BotaoAlterarData: React.FC<BotaoAlterarDataProps> = ({ inventario, disabled }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                variant="link"
                size="sm"
                className="p-0 ms-2"
                onClick={() => setShowModal(true)}
                disabled={disabled}
            >
                <FontAwesomeIcon icon={faEdit} className="me-1" />
                Alterar Data
            </Button>

            <ModalAlterarData
                show={showModal}
                onHide={() => setShowModal(false)}
                inventario={inventario}
            />
        </>
    );
};

export default BotaoAlterarData; 